function d(t) {
  let e = t, n = !1;
  e.startsWith("[REQUIRED] ") && (n = !0, e = e.slice(11));
  const r = e.indexOf(`
---
`);
  return r !== -1 ? {
    label: e.slice(0, r),
    description: e.slice(r + 5),
    required: n
  } : { label: e, description: "", required: n };
}
function g(t) {
  const e = t ?? "";
  return !!(e.includes(`
---
`) || e.startsWith("[REQUIRED] "));
}
function y(t) {
  var r;
  const e = d(t.prompt), n = (r = t.hint) == null ? void 0 : r.trim();
  return {
    label: e.label,
    description: n || e.description,
    required: e.required
  };
}
function c(t) {
  return !t || typeof t != "object" ? null : t;
}
function u(t) {
  if (t == null) return null;
  if (typeof t == "string") {
    const e = t.trim();
    if (!e) return null;
    try {
      const n = JSON.parse(e);
      return c(n);
    } catch {
      return null;
    }
  }
  return c(t);
}
function s(t) {
  return c(t.firm_authored_content ?? t.firmAuthoredContent);
}
function l(t) {
  const e = t.client_action ?? t.clientAction;
  return typeof e == "string" ? e : void 0;
}
function a(t) {
  const e = u(t);
  if (!e) return !1;
  const n = e.is_custom_step ?? e.isCustomStep;
  return n === !0 || n === "true" || n === 1;
}
function p(t) {
  return t ? Object.keys(t).length === 0 : !0;
}
function m(t) {
  const e = l(t);
  if (e != null && e !== "approve") return !1;
  const n = s(t);
  if (!n || Object.keys(n).length === 0) return !1;
  const r = String(n.contentType ?? n.content_type ?? "").toLowerCase();
  if (r === "file") return !1;
  if (r === "text") return !0;
  const i = n.textContent ?? n.text_content;
  return typeof i == "string" && i.trim().length > 0;
}
function x(t, e, n) {
  if (n === "WfiFirmAuthoredTextAcknowledgement" || n === "firm_authored_text")
    return !0;
  if (a(t)) {
    const i = u(t);
    if (!i) return !0;
    const f = l(i);
    if (f != null && f !== "approve") return !1;
    const o = s(i);
    return !o || Object.keys(o).length === 0 ? !0 : String(o.contentType ?? o.content_type ?? "").toLowerCase() !== "file";
  }
  const r = u(t);
  return !!(r && m(r) || e !== void 0 && (e ?? "").includes(`
---
`) && p(r));
}
function A(t) {
  const e = u(t);
  if (!e) return "";
  const n = s(e);
  if (!n) return "";
  const r = n.textContent ?? n.text_content;
  return typeof r == "string" ? r.trim() : "";
}
export {
  d as decodeFieldPrompt,
  y as getFieldDisplayParts,
  A as getFirmAuthoredTextBody,
  g as isEncodedCustomFieldPrompt,
  x as isFirmAuthoredTextAcknowledgeStep,
  a as isWorkflowCustomStep
};
//# sourceMappingURL=workflow-field-display.js.map
